import { render, staticRenderFns } from "./attendance.vue?vue&type=template&id=a8527080&scoped=true&"
import script from "./attendance.vue?vue&type=script&lang=js&"
export * from "./attendance.vue?vue&type=script&lang=js&"
import style0 from "./attendance.vue?vue&type=style&index=0&id=a8527080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8527080",
  null
  
)

export default component.exports